/*
    Copyright (c) Computer-L.A.N. GmbH (http://www.computer-lan.de).
    Alle Rechte vorbehalten.
*/

import { ButtonBaseActions } from "@mui/material";
import YesNoDialogProps from "./YesNoDialogProps";

export default class YesNoDialogModel {
    public constructor(private readonly _props: YesNoDialogProps) {}

    public get isOpen(): boolean {
        return this._props.isOpen;
    }

    public get isWarning(): boolean {
        return this._props.variant === "warning";
    }

    public get isDanger(): boolean {
        return this._props.variant === "danger";
    }

    public get dialogCaption(): string {
        return this._props.dialogCaption;
    }

    public get dialogText(): React.ReactNode {
        return this._props.dialogText;
    }

    public get innerContainerClassName(): string {
        return "lan-yesnodialog__innercontainer";
    }

    public get warningIndicatorClassName(): string {
        return "lan-yesnodialog__innercontainer__indicator lan-yesnodialog__innercontainer__indicator--warning";
    }

    public get dangerIndicatorClassName(): string {
        return "lan-yesnodialog__innercontainer__indicator lan-yesnodialog__innercontainer__indicator--danger";
    }

    public get mainClassName(): string {
        return "lan-yesnodialog__innercontainer__main";
    }

    public get titleClassName(): string {
        return "lan-yesnodialog__innercontainer__main__title";
    }

    public get warningIconClassName(): string {
        return "lan-yesnodialog__innercontainer__main__title__icon lan-yesnodialog__innercontainer__main__title__icon--warning";
    }

    public get dangerIconClassName(): string {
        return "lan-yesnodialog__innercontainer__main__title__icon lan-yesnodialog__innercontainer__main__title__icon--danger";
    }

    public ja = () => {
        this._props.onYes();
    };

    public nein = () => {
        this._props.onNo();
    };

    public yesButtonAction = (instance: ButtonBaseActions | null) => {
        if (this._props.focusOn === "yes") {
            instance?.focusVisible();
        }
    };

    public noButtonAction = (instance: ButtonBaseActions | null) => {
        if (this._props.focusOn === "no") {
            instance?.focusVisible();
        }
    };
}
